import { getEnvironment } from "../../helpers/fetching";
import mutations from "../mutations";

export default {
  state: {
    environment: {},
    scheduling: {},
    loading: false,
    error: null,
  },
  mutations,
  actions: {
    /* eslint-disable */
    fetchEnvironment({ commit }) {
      return new Promise(async (resolve) => {
        commit("setState", { key: "loading", value: true });
        
        let response = await new Promise(resolve => {
          getEnvironment(resolve);
        })
         
        commit("setState", { key: "environment", value: response });
        commit("setState", { key: "scheduling", value: response.scheduling || {} });
        commit("setState", { key: "loading", value: false });
        resolve();
      });
    },
    resetEnvironment({ commit }) {
      commit("setState", { key: "environment", value: {} });
    },
    /* eslint-enable */
  },
};
